/* ==========================================================================
   Chrune engraving rules

   Two rules that apply to every personalisation field on the site, on the
   product page and in the personalisation tool alike:

     1. Only the letters A to Z without accents (upper and lower case), digits,
        spaces, full stops and slashes can be engraved. Accents and every other
        character are refused and the add to cart is blocked while one is
        still there.
     2. Every field the chosen piece offers must be filled. A variant sold as
        engraved on three sides is made with three texts, so an empty field
        would reach the manufacturer as an engraving with nothing on it.

   On the product page it gates the existing form rather than replacing it:
   the listener runs in the capture phase, so it stops the theme's own submit
   handler before it fires. theme.js is untouched.

   The personalisation tool uses the same rules through the small API
   published at the bottom.
   ========================================================================== */
(function () {
  'use strict';

  /* Plain ASCII letters only: LEA is accepted, LÉA is refused on the É. */
  var FORBIDDEN = /[^A-Za-z0-9 .\/]/;

  function firstForbidden(value) {
    var match = String(value == null ? '' : value).match(FORBIDDEN);
    return match ? match[0] : null;
  }

  function fill(template, char) {
    return String(template || '').replace('%CHAR%', char);
  }

  /* Only the fields the customer can actually see count: the engraving box
     and individual fields are hidden as the chosen option changes. */
  function liveInputs(form) {
    var box = form.querySelector('[data-engrave]');
    if (!box || box.hidden) return [];
    return Array.prototype.filter.call(form.querySelectorAll('[data-engrave-input]'), function (input) {
      var field = input.closest('[data-engrave-field]');
      return !input.disabled && !(field && field.hidden);
    });
  }

  /* theme.js marks only the first visible field as required when the option
     changes. Every visible field is required, so the attribute is put back on
     all of them afterwards: this listener sits on the document, which the
     change reaches after the option input's own handler. */
  function syncRequired() {
    Array.prototype.forEach.call(document.querySelectorAll('.pdp__form'), function (form) {
      var live = liveInputs(form);
      Array.prototype.forEach.call(form.querySelectorAll('[data-engrave-input]'), function (input) {
        if (live.indexOf(input) !== -1) {
          input.setAttribute('required', 'required');
          input.setAttribute('aria-required', 'true');
        } else {
          input.removeAttribute('required');
          input.removeAttribute('aria-required');
        }
      });
    });
  }

  function statusNode(form) {
    var root = form.closest('[data-product-root]') || document;
    return root.querySelector('[data-add-status]');
  }

  function say(form, message, isError) {
    var node = statusNode(form);
    if (!node) return;
    node.textContent = message || '';
    node.classList.toggle('is-error', !!isError);
  }

  function messages(form) {
    var box = form.querySelector('[data-engrave]');
    var button = form.querySelector('[data-add-button]');
    return {
      charset: box ? box.getAttribute('data-msg-charset') : '',
      required: button ? button.getAttribute('data-message-engraving') : ''
    };
  }

  /* ------------------------------------------------------------------ *
   * Product form
   * ------------------------------------------------------------------ */

  document.addEventListener(
    'submit',
    function (event) {
      var form = event.target;
      if (!form.classList || !form.classList.contains('pdp__form')) return;

      var inputs = liveInputs(form);
      if (!inputs.length) return;

      var badChar = null;
      var badInput = null;
      var emptyInput = null;

      inputs.forEach(function (input) {
        var found = firstForbidden(input.value);
        var empty = !input.value.trim();
        input.setAttribute('aria-invalid', found || empty ? 'true' : 'false');
        if (found && !badChar) {
          badChar = found;
          badInput = input;
        }
        if (empty && !emptyInput) emptyInput = input;
      });

      if (!badChar && !emptyInput) return;

      event.preventDefault();
      event.stopPropagation();

      var copy = messages(form);
      if (badChar) {
        say(form, fill(copy.charset, badChar), true);
        badInput.focus();
      } else {
        say(form, copy.required, true);
        emptyInput.focus();
      }
    },
    true
  );

  /* Live feedback: the customer should not have to press Add to cart to find
     out a character is refused. */
  document.addEventListener('input', function (event) {
    var input = event.target.closest ? event.target.closest('[data-engrave-input]') : null;
    if (!input) return;

    var form = input.closest('.pdp__form');
    if (!form) return;

    input.setAttribute('aria-invalid', firstForbidden(input.value) ? 'true' : 'false');

    var offenders = liveInputs(form)
      .map(function (field) { return firstForbidden(field.value); })
      .filter(Boolean);

    if (offenders.length) {
      say(form, fill(messages(form).charset, offenders[0]), true);
    } else {
      var node = statusNode(form);
      if (node && node.classList.contains('is-error')) say(form, '', false);
    }
  });

  document.addEventListener('change', function (event) {
    if (event.target.closest && event.target.closest('[data-option-input]')) syncRequired();
  });

  /* ------------------------------------------------------------------ *
   * Shared with the personalisation tool
   * ------------------------------------------------------------------ */

  window.CHRUNE_ENGRAVE = {
    forbidden: firstForbidden,
    fill: fill
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', syncRequired);
  } else {
    syncRequired();
  }
})();